import React from 'react';

import HighlightedText from '@marketing/components/highlighted_text';

import WallOfLoveSection from '../../../sections/wall_of_love';

import EleanoreHeadshot from './assets/eleanore_headshot.png';

export default (props) => {
  return (
    <WallOfLoveSection
      featuredQuote={{
        studentName: 'Eleanore P.',
        studentAffiliation: 'Magoosh Student - 2021',
        content: (
          <>
            "The best thing for me about Magoosh was <HighlightedText color="#FCF0BF">the flexibility</HighlightedText> because I don't have a lot of free time.  I could come home in the evenings, do video lessons, and that made all the difference. Magoosh being within my price range was the difference between me potentially getting into grad school and not getting in anywhere."
          </>
        ),
        image: {
          height: '329px',
          src: EleanoreHeadshot,
          width: '409px'
        },
        video: {
          sources: [
            {
              src: 'https://d296n67kxwq0ge.cloudfront.net/audio_video/a8088d957a694715f2bf06bba05aba781afdb197-video-23093/web.mp4',
              type: 'video/mp4'
            },
            {
              src: 'https://d296n67kxwq0ge.cloudfront.net/audio_video/a8088d957a694715f2bf06bba05aba781afdb197-video-23093/web_webm.webm',
              type: 'video/webm'
            }
          ]
        }
      }}
      quotes={[
        {
          studentName: 'Atharv V.',
          studentAffiliation: 'Magoosh Student - 2025',
          content: (
            <>
              "Vast question bank provided for various levels of questions with helpful explanations. Also, <HighlightedText color="#FCF0BF">the AI tutor</HighlightedText> helped clear any further doubts."
            </>
          )
        },
        {
          studentName: 'Emily Z.',
          studentAffiliation: 'Magoosh Student - 2023',
          content: (
            <>
              "There were plenty of practice questions and tests available, and everything was super easy to use! A bonus is that Magoosh has <HighlightedText color="#FCF0BF">official ETS practice sections</HighlightedText>, which is super helpful."
            </>
          )
        },
        {
          studentName: 'Alexander W.',
          studentAffiliation: 'Magoosh Student - 2023',
          content: (
            <>
              "<HighlightedText color="#FCF0BF">The vocab app</HighlightedText> was exceedingly helpful. That alone got me a bunch of questions on the Verbal Reasoning section of the actual exam."
            </>
          )
        },
        {
          studentName: 'Sanjana D.',
          studentAffiliation: 'Magoosh Student - 2022',
          content: (
            <>
              "The practice questions and practice tests were extremely useful. <HighlightedText color="#FCF0BF">The score predictor</HighlightedText> was on point and I ended up scoring the same as my last Magoosh practice test."
            </>
          )
        }
      ]}
    />
  );
};
